import type { MaybeRef } from "@vueuse/core"
import type { RouteLocationNormalized } from "vue-router"
import { computed, unref } from "vue"

export default (to?: MaybeRef<RouteLocationNormalized>) =>
  computed(
    () => (unref(to)?.params.nickname as string) || localStorage.getItem("manufacturer")
  )
